"use strict";

exports.__esModule = true;
var _CreateDashboardScreen = require("./CreateDashboardScreen");
Object.keys(_CreateDashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateDashboardScreen[key]) return;
  exports[key] = _CreateDashboardScreen[key];
});